export const colorListX = [
  '#F94144',
  '#F3722C',
  '#F8961E',
  '#F9844A',
  '#F9C74F',
  '#90BE6D',
  '#43AA8B',
  '#4D908E',
  '#577590',
  '#277DA1',
  '#03045E',
  '#03045E',
  '#023E8A',
  '#0077B6',
  '#0096C7',
  '#00B4D8',
  '#48CAE4',
  '#90E0EF',
  '#ADE8F4',
  '#CAF0F8',
];

export const colorList = [
  '#DC143C', // 원래 네 번째 - Crimson
  '#20B2AA', // LightSeaGreen
  '#DAA520', // GoldenRod
  '#6A5ACD', // SlateBlue
  '#32CD32', // LimeGreen
  '#FF7F50', // Coral
  '#8A2BE2', // BlueViolet
  '#708090', // SlateGray
  '#CD5C5C', // IndianRed
  '#4169E1', // RoyalBlue
  '#9932CC', // DarkOrchid
  '#3CB371', // MediumSeaGreen
  '#A0522D', // Sienna
  '#B22222', // FireBrick
  '#4682B4', // SteelBlue
  '#5F9EA0', // CadetBlue
  '#8B4513', // SaddleBrown
  '#1F1F1F', // Very dark gray
  '#2E8B57', // SeaGreen
  '#556B2F', // DarkOliveGreen
];
